class VideoSwitcherExternal extends HTMLElement {
  connectedCallback() {
    this.iframe = this.querySelector('iframe');

    if (this.iframe) {
      this.bindVideoSwitcher();
    }
  }

  bindVideoSwitcher() {
    const desktopSrc = this.iframe.dataset.srcDesktop;
    let mobileSrc = desktopSrc;

    if (this.iframe.dataset.srcMobile) {
      mobileSrc = this.iframe.dataset.srcMobile;
    }

    const mediaQueryList = window.matchMedia('(max-width: 767px)');

    const handleViewportChange = (mql) => {
      const isMobile = mql.matches;
      const newSrc = isMobile ? mobileSrc : desktopSrc;

      if (this.iframe.src !== newSrc) {
        this.iframe.src = newSrc;
      }
    };

    handleViewportChange(mediaQueryList);
    mediaQueryList.addEventListener('change', handleViewportChange);
  }
}

customElements.define('video-switcher-external', VideoSwitcherExternal);
